<template>
    <v-layout justify-center>
        <v-responsive :max-width="maxWidth" width="100%" height="100%" class="shop-product-view">
            <div class="headline text-start mt-8">{{ headline }}</div>
            <slot />
        </v-responsive>
    </v-layout>
</template>

<script>
export default {
    props: {
        headline: String,
        maxWidth: { type: String, default: "1024px" },
    },
};
</script>
